export default class Properties {
  constructor({
    city,
    region,
    apiId,
    country,
    shortName,
    longName,
    placeType,
    wikibase,
    category,
    department,
    administrative
  } = {}) {
    this.city = city || {};
    this.department = department || "";
    this.administrative = administrative || {};
    this.region = region || {};
    this.apiId = apiId || "";
    this.country = country || "";
    this.shortName = shortName || "";
    this.longName = longName || "";
    this.placeType = placeType || "";
    this.wikibase = wikibase || "";
    this.category = category || "";
  }
  getDataForCreateOrEditPost() {
    return {
      api_id: this.apiId,
      short_name: this.shortName,
      long_name: this.longName,
      place_type: this.placeType,
      wikibase: this.wikibase,
      category: this.category
    };
  }
}
